import { fetchApi } from "../../app/lib/api"
import { Types } from './types'
import { actionLoading } from '../home/actions'
import { checkErrorCode } from '../auth/actions'
import { LIMIT_PAGE } from '../../lib/common'

//////////////////////////////////POST/////////////////////////////////////////
export const actionGetPostById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post/get-detail-post`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetExpertById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/user/get-detail-expert-by-id`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}
export const actionGetCategoryById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post/get-detail-category`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetListPost = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        if (!payload)
            payload = {}
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post/get-list-post`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListPost(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetListPostAgency = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        if (!payload)
            payload = {}
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post_agency/get-list-post`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListPostAgency(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}
export const actionDetailReviewPost = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE
        let response = await fetchApi(`/admin/post_agency/get-detail-review`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}


export const actionGetListAgencyPost = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        if (!payload)
            payload = {}
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post_agency/get-list-agency-have-post`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveListAgencyPost(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}


export const actionUpdatePostAgency = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post_agency/update-post`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        const state = getState()
        const dataPostAgency = state?.postReducer?.dataPostAgency

        let newData = { ...dataPostAgency }
        console.log("datapushhhhhhhhhhhhhhhhhh", dataPush);
        const index = newData.rows.findIndex(it => it.id === dataPush.id)

        console.log("indexxxxxxxxxxxxxxx", index);

        newData.rows[index] = response.data
        await dispatch(actionGetListPostAgency(filterModal))

        dispatch(actionLoading(false))
        return response
    } catch (error) {

        console.log(error); alert(error || error?.message)
    }
}

export const actionDeletePostAgency = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post_agency/delete-post`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListPostAgency(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}



export const actionUpdatePost = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post/update-post`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListPost(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataPost = state?.postReducer?.dataPost
            let newData = { ...dataPost }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListPost(filterModal))
        }
        dispatch(actionLoading(false))
        return response
    } catch (error) {

        console.log(error); alert(error || error?.message)
    }
}

export const actionDeletePost = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post/delete-post`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListPost(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionSaveListPost = (payload) => ({
    type: Types.SAVE_LIST_POST,
    payload,
})
export const actionSaveListPostAgency = (payload) => ({
    type: Types.SAVE_LIST_POST_AGENCY,
    payload,
})
export const actionSaveListAgencyPost = (payload) => ({
    type: Types.SAVE_LIST_AGENCY_POST,
    payload,
})
//////////////////////////////////END//////////////////////////////////////////

//////////////////////////////////TAG/////////////////////////////////////
export const actionGetListPostTag = (payload) => async (dispatch, getState) => {
    try {

        dispatch(actionLoading(true))
        let { page } = payload || {}
        if (!payload) {
            payload = {}
        }
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post/get-list-post-tag`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                limit: LIMIT_PAGE
            }
        }
        await dispatch(actionSaveTag(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)

    }
}

export const actionGetAllPostTag = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post/get-all-post-tag`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        await dispatch(actionSaveAllTag(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}
export const actionUpdatePostTag = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post/update-post-tag`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListPostTag(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataTag = state?.postReducer?.dataTag
            let newData = { ...dataTag }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListPostTag(filterModal))
        }
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}
export const actionDeletePostTag = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post/delete-post-tag`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListPostTag(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}
export const actionSaveTag = (payload) => ({
    type: Types.SAVE_LIST_TAG,
    payload,
})
export const actionSaveAllTag = (payload) => ({
    type: Types.SAVE_ALL_TAG,
    payload,
})

//////////////////////////////////END/////////////////////////////////////

//////////////////////////////////CATEGORY/////////////////////////////////////
export const actionGetCategory = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post/get-list-post-category`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionSaveCategory(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetListPostCategory = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        let _payload = {
            ...payload,
            limit: payload?.limit ?? LIMIT_PAGE,
            page:payload?.page ?? 1
        }

        let response = await fetchApi(`/admin/post/get-all-post-category`, "get", _payload)
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        response.data = {
            ...response.data,
            paging: {
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / LIMIT_PAGE),
                ..._payload
            }
        }

        await dispatch(actionSavePostCategory(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionUpdatePostCategory = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post/update-post-category`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListPostCategory(filterModal))
        }
        //sửa
        else {
            const state = getState()
            const dataPostCategory = state?.postReducer?.dataPostCategory
            let newData = { ...dataPostCategory }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListPostCategory(filterModal))
        }
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionDeleteCategory = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post/delete-post-category`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListPostCategory(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetListAuthorCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-author-cms`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListAuthorCMS(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListExpertCMS = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/user/get-list-expert-cms`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListExpertCMS(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionGetListCategorySEO = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page, limit } = payload

        let response = await fetchApi(`/admin/post/get-footer-list`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        response.data = {
            ...response.data,
            paging: {
                page: page || 1,
                total: response?.data?.total || 0,
                count: Math.ceil((response?.data?.total) / limit),
                limit: limit
            }
        }
        await dispatch(actionSaveListCategorySEO(response.data))
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionDeleteAuthorCMS = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/user/delete-author-cms`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListAuthorCMS(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionDeleteExpertCMS = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/user/delete-expert-cms`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListExpertCMS(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        alert(error || error?.message)
    }
}

export const actionCreateAuthor = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/create-author`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListAuthorCMS({page: 1, limit: 15, ...filterModal}))
        }
        //sửa
        else {
            const state = getState()
            const dataAuthorCMS = state?.postReducer?.dataAuthorCMS
            let newData = { ...dataAuthorCMS }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListAuthorCMS({page: 1, limit: 15, ...filterModal}))
        }
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionCreateExpert = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/user/create-expert`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListExpertCMS({page: 1, limit: 15, ...filterModal}))
        }
        //sửa
        else {
            const state = getState()
            const dataExpertCMS = state?.postReducer?.dataExpertCMS
            let newData = { ...dataExpertCMS }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListExpertCMS({page: 1, limit: 15, ...filterModal}))
        }
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionCreateCategorySEO = (payload) => async (dispatch, getState) => {
    const { dataPush, filterModal } = payload

    try {
        dispatch(actionLoading(true))
        let response = await fetchApi(`/admin/post/create-footer`, "post", dataPush)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        //thêm
        if (!payload.id) {
            await dispatch(actionGetListCategorySEO({page: 1, limit: 15, ...filterModal}))
        }
        //sửa
        else {
            const state = getState()
            const dataCategorySEO = state?.postReducer?.dataCategorySEO
            let newData = { ...dataCategorySEO }

            const index = newData.rows.findIndex(it => it.id === payload.id)
            newData.rows[index] = response.data
            await dispatch(actionGetListCategorySEO({page: 1, limit: 15, ...filterModal}))
        }
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionGetTextFooterById = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const { page } = payload
        payload.limit = LIMIT_PAGE

        let response = await fetchApi(`/admin/post/get-footer-seo-id`, "get", payload)

        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }
        dispatch(actionLoading(false))
        return response.data
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionDeleteTextFooter = (payload) => async (dispatch, getState) => {
    const { id, filterModal } = payload
    try {
        dispatch(actionLoading(true))

        let response = await fetchApi(`/admin/post/delete-footer`, "post", { id })
        if (response.code !== 200) {
            dispatch(actionLoading(false))
            return checkErrorCode(response?.code, response?.message)
        }

        await dispatch(actionGetListCategorySEO(filterModal))
        dispatch(actionLoading(false))
        return response.code
    } catch (error) {
        console.log(error); alert(error || error?.message)
    }
}

export const actionSaveListAuthorCMS = (payload) => ({
    type: Types.SAVE_LIST_AUTHOR_CMS,
    payload,
})

export const actionSaveListExpertCMS = (payload) => ({
    type: Types.SAVE_LIST_EXPERT_CMS,
    payload,
})

export const actionSaveListCategorySEO = (payload) => ({
    type: Types.SAVE_LIST_CATEGORY_SEO_CMS,
    payload,
})

export const actionSaveCategory = (payload) => ({
    type: Types.SAVE_LIST_CATEGORY,
    payload,
})

export const actionSavePostCategory = (payload) => ({
    type: Types.SAVE_LIST_POST_CATEGORY,
    payload,
})

///////////////////////////////////END CATEGORY/////////////////////////////////////